// @flow
import type { Preference } from '.';

const keyboardShortcuts = {
  reporterPrevious: {
    id: 'REPORTER_PREVIOUS',
    description: 'Focus previous',
    iconName: 'skip_previous',
    category: 'REPORTER',
  },
  reporterNext: {
    id: 'REPORTER_NEXT',
    description: 'Focus next',
    iconName: 'skip_next',
    category: 'REPORTER',
  },
  reporterToggleDictation: {
    id: 'REPORTER_TOGGLE_DICTATION',
    description: 'Toggle dictation',
    iconName: 'fiber_manual_record',
    category: 'REPORTER',
  },
};

export const getKeyboardShortcutById = (id: string, interactionId: ?string): ?Preference =>
  // $FlowFixMe[incompatible-use]
  // $FlowFixMe[incompatible-type]
  Object.values(keyboardShortcuts).find((ks) => ks.id === id);

export default keyboardShortcuts;
